import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  updateUnsubmittedOfferByCid,
  reviewUnsubmittedOffer,
  submitOffers,
  refreshOddsData,
} from '@xanadu/ui-shared/modules/unsubmittedOffers/actions';

import {
  updateOfferByUser,
  submitEditedOffersByIds,
  reviewOpenOffer,
} from '@xanadu/ui-shared/modules/openOffers/actions';

import {
  toggleDisplay,
} from '@xanadu/ui-shared/modules/betslip/actions';

import { EMPTY_LIST } from '../../../constants';
import Betslip from '../../../components/betslip/Betslip';

const mapDispatchToProps = {
  updateUnsubmittedOfferByCid,
  reviewUnsubmittedOffer,
  submitOffers,
  updateOfferByUser,
  reviewOpenOffer,
  submitEditedOffersByIds,
  toggleDisplay,
  refreshOddsData,
};

function mapStateToProps(state) {
  return {
    oddsType: state.getIn(['user', 'oddsType']),
    openOffers: state.getIn(['openOffers', 'data']),
    betBuilderOffers: state.getIn(['betBuilder', 'betBuilderOffers']),
    sidebarVisible: state.getIn(['rightSidebar', 'visible']),
    sidebarContent: state.getIn(['rightSidebar', 'content']),
    sidebarMetadata: state.getIn(['rightSidebar', 'metadata']),
    unsubmittedOffers: state.get('unsubmittedOffers'),
    betslipSettledBets: state.getIn(['settledBets', 'betslip', 'bets']) || EMPTY_LIST,
    betBuilderRestricted: state.getIn(['betBuilder', 'restricted']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Betslip));
